export const PATH_APP = {
  root: '/',
  welcome: '/welcome',
  visitor: '/visitor',
  delivery: '/delivery',
};
